
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-adPaster\">\n    <div class=\"c-adPaster__exitBox\">\n        <div class=\"c-adPaster__exit\"></div>\n    </div>\n    <div class=\"c-adPaster__time\">广告剩余时间<span>")
    ; __append(escape(durations))
    ; __append("s</span></div>\n    <div class=\"c-adPaster__mute\"></div>\n    <div class=\"c-adPaster__more\">了解详情 ></div>\n    ")
    ;  if (adUrls.length) { 
    ; __append(" \n	")
    ;  adUrls.forEach(function(src,index){ 
    ; __append("<video class=\"advideo\" data-tag=\"")
    ; __append(escape(index))
    ; __append("\"  style=\"\" src=\"")
    ; __append(escape(src))
    ; __append("\" id=\"adPlayer\" preload=\"auto\" playsinline='playsinline' webkit-playsinline='webkit-playsinline' control=\"false\"></video>")
    ;  }) 
    ; __append("\n	")
    ;  } 
    ; __append(" \n</div>\n\n\n\n ")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdCore/main.ejs
// module id = 533
// module chunks = 0